export default __webpack_public_path__ + "static/media/emp.dcebb25e.mpeg";